
export default {
  async asyncData({ $axios,app, req, route, commit, store, redirect }) {
    let brands = []
    let initials = []
    try {
      let temp = await $axios.$get(
        `${process.env.axiosUrl}/items/sv/distinct?store_id=${store.state.store.store_id}&fields=manufacturer`,
        {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        }
      );
      brands = temp.manufacturer
      initials = [...new Set(brands.filter(b=>b.key&&b.key!= ' '&&b.key!="'").map((b) => app.$hyperUtility.equalize(b.key[0])))];
    } catch (e) {
      console.error(e);
    }
    return { brands,initials };
  },
  head() {
    return { title: `Brands - ${this.$store.getters.store.eshop.name}` };
  },
  data() {
    return {
      brands: [],
      initials:[]
    };
  },
};
